'use strict'
let $ = require('jquery')

$(function () {
  /**
   * Handle references ajax functions
   */
  if (
    $('body').hasClass('page-template-archive-gw_ahola_references') ||
    $('body').hasClass('page-template-archive-gw_ahola_articles')
  ) {
    /**
     * Listen for page changes
     */
    window.addEventListener('popstate', event => {
      let pageNr = findGetParameter('number')
      let category = findGetParameter('cat')

      if (category) hideFeaturedPost()

      getPostsPerPage(pageNr, category)
    })

    /** ------------------------ */

    // Get page number, will be validated server side
    let number = findGetParameter('number')
    let category = findGetParameter('cat')
    let isFirstPage = number == 1

    // If no page number in url, redirect to number 1
    if (number === null) {
      number = 1
      refreshPath(buildArchiveUrl(number, category))
    } else if (!isFirstPage) {
      // Hide featured if not firstpage
      hideFeaturedPost()
    } else if (isFirstPage && category) {
      hideFeaturedPost()
    }

    /**
     * Clicking on pagination
     */
    $('.pagination-number').on('click', function () {
      $('.post-pagination button').each(function () {
        $(this).removeClass('active')
      })
      $(this).addClass('active')
      let pageNr = $(this).attr('data-pagination')
      let type = $(this).attr('data-type')
      getPostsPerPage(pageNr, findGetParameter('cat') ?? null)
    })

    /**
     *
     * Fetch posts for current page (pagination)
     * @param number pageNr
     * @param string postType
     * @param number categoryId
     *
     */
    function getPostsPerPage (pageNr, category = null) {
      const postType = getPostTypeFromBodyClasses()

      let perPage = postType === 'articles' ? 9 : 4
      const payload = {
        action: 'get_paginated_posts',
        posttype: postType,
        postpage: pageNr,
        perpage: perPage
      }
      if (category) payload.category = category
      $.ajax({
        url: page.admin_ajax,
        dataType: 'json',
        type: 'POST',
        data: payload,
        beforeSend: function () {
          // if (pageNr === 1)
          if (pageNr != 1 && !category) {
            $('.component--featured-post-item').hide()
          }
          $('.single').fadeOut()

          if (!category) {
            $([document.documentElement, document.body]).animate(
              {
                scrollTop:
                  $(`.contentblock--${postType}-list`).offset().top - 200
              },
              500
            )
          }
        },
        success: function (data) {
          if (postType === 'articles') {
            $(
              '.contentblock--articles-list > .swiper-container > .swiper-wrapper'
            ).empty()
            $(
              '.contentblock--articles-list > .swiper-container > .swiper-wrapper'
            ).append(data.html)
          } else {
            $('.contentblock--' + postType + '-list').empty()
            $('.contentblock--' + postType + '-list').append(data.html)
          }
          $('.single')
            .hide()
            .fadeIn()

          const refresh = new URL(window.location)
          refresh.searchParams.set('number', pageNr)

          window.history.pushState({ path: refresh.href }, '', refresh.href)

          if (pageNr == 1 && !category) {
            $('.component--featured-post-item')
              .hide()
              .fadeIn()
          }
        }
      })
    }

    /**
     * Get value for parameter in url
     * @param string parameterName
     * @returns string  value for parameter key
     */
    function findGetParameter (parameterName) {
      let result = null,
        tmp = []
      location.search
        .substr(1)
        .split('&')
        .forEach(function (item) {
          tmp = item.split('=')
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
        })
      return result
    }

    /**
     * Checks the body classes and returns post type on basis of archive type
     */
    function getPostTypeFromBodyClasses () {
      if ($('body').hasClass('page-template-archive-gw_ahola_references')) {
        return 'references';
      }

      if($('body').hasClass('page-template-archive-gw_ahola_articles')) {
        return 'articles'
      }

      return false;
    }

    /**
     * Check if value is numeric
     * @param {*} str
     * @returns true if numeric, false if not
     */
    function isNumeric (str) {
      if (typeof str != 'string') return false
      return !isNaN(str) && !isNaN(parseFloat(str))
    }

    /**
     * Builds URL with parameters
     */
    function buildArchiveUrl (number, category) {
      let url =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname

      if (!number && !category) return url

      if (number && !category) {
        url += `?number=${number}`
        return url
      }

      if (category && !url) {
        url += `?cat=${category}`
        return url
      }

      url += `?number=${number}&cat=${category}`

      return url
    }

    /**
     * Refresh URL and handle action
     */
    function refreshPath (path) {
      window.history.pushState({ path: path }, '', path)
      let popStateEvent = new PopStateEvent('popstate', { path: path })
      dispatchEvent(popStateEvent)
    }

    /**
     * Hides featured post
     */
    function hideFeaturedPost () {
      $('.component--featured-post-item').hide()
    }
  }
})
